
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index1JMfyR5uxmAxVAMCNwWyLFLkMFIP_45vKAlIfzNfa8cGUMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/index.vue?macro=true";
import { default as loginYtQa9SSmc3ZqUtC_3jL1kzHZ7vJtjHCZbJelGF3_45YuYMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/login.vue?macro=true";
import { default as indexI3c4ByUkGpBpdfEj85UCmQOTgoxkl2fi72KPC6xOAagMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/users/index.vue?macro=true";
import { default as indexogOFUltNIzujgGBGeGpfzY6gaY7kpDskrlY5EHosOMUMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/index.vue?macro=true";
import { default as login_45passwordR1lcTWl9C7J4WsPDY9KS8VW5daDDwyncETSIj0tPm_cMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/login-password.vue?macro=true";
import { default as _91role_93SQMt0_9T5qLuyCLZJNXDhNVQMaoBinfiQJo8iRccZQIMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/users/new/[role].vue?macro=true";
import { default as _91type_93AwDTcoFheQDjPl4pAn9Kp6kQSoeb5LOL23AyVYK11A8Meta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/new/[type].vue?macro=true";
import { default as inforrGSI0OIciRsGMYPWjXnWE9KOGqJQSZCJ1KJUBk0810Meta } from "/codebuild/output/src489166772/src/cb-admin/pages/users/[userId]/index/info.vue?macro=true";
import { default as indexIMB13u9chmNSnBEhggd9IYonaPq6mIxi7HR_f35YKvIMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/users/[userId]/index.vue?macro=true";
import { default as indexhdHcplbdaxoa05GEHn0KWrW4ogw_45Ziuupk3P3svbkU8Meta } from "/codebuild/output/src489166772/src/cb-admin/pages/student-progress/index.vue?macro=true";
import { default as infoYqBC3DZlGh8fb54h_b_459DMSYK03eNShPelGRvbO0lpYMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/info.vue?macro=true";
import { default as newV6owiAwZocUSIiy_RWAlOUS_45iK5LhsxfBoHK7934KbAMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/schools/new.vue?macro=true";
import { default as newVoFBkY1AvBgAaoy4SL5oOwUezvOUIlJoTha4efZTymYMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/licenses/new.vue?macro=true";
import { default as neweWEOayBSkFMQ83dDpxJKUiRGTaBsp36Xy3smqKfwczAMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/students/new.vue?macro=true";
import { default as newBLrztZQO8dZKVVfhOv_45YsQp6TuJBSR9_PN7gBhi1aeIMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/teachers/new.vue?macro=true";
import { default as indexDA9ehZwmtddXFtcMPkBNHMFl0YAUOARUNvcRPo_D4s0Meta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/schools/index.vue?macro=true";
import { default as newqvThBVayJ2ixUmjmmEZVjJFilQL61ib8nMMi5MLN0g8Meta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/classrooms/new.vue?macro=true";
import { default as indexo4VHpSt2Vd7Np_8GA_XrnBbbjk0cmQ6jHCF_45SBLipLMMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/licenses/index.vue?macro=true";
import { default as indexdUrx46dfTp3MxyWg3yhhe1n6xkiBbdpk9ygDVKiI7Q8Meta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/students/index.vue?macro=true";
import { default as indexqSJp3Cy8urfaMLoZoRnGofFRc1FojZ5wDur_45i5qFkfwMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/teachers/index.vue?macro=true";
import { default as indexW0LwEwWoq8K5MjUhc0EQ1uf6SJnFEznD4IoaGFVafloMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/classrooms/index.vue?macro=true";
import { default as newrGnez_6pV7ij5skCYUvlrNcQh5LFwfq4C4kgKpMRPYgMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/school-admins/new.vue?macro=true";
import { default as newCuTMNAiEEvnDyYWE2MqlMse4_45_45jPgaSKCKxuL47hEzEMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/district-admins/new.vue?macro=true";
import { default as indexl9gHp_eLqB_45Qw5JzkSKXnNPK_dkxKDQdxQki5c7D4Y8Meta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/school-admins/index.vue?macro=true";
import { default as _91groupId_93V7GqWgluoUhmPXAVRDW_syLDamhwmd_731TJFK0soGAMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/classrooms/[groupId].vue?macro=true";
import { default as _91licenseId_93Y0TrswD4gPVro6EaUftyDJCctmU45wlEyttAkqMvLCUMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/licenses/[licenseId].vue?macro=true";
import { default as _91studentId_93xmts8YA4U0IcawFKVrEZ4WxUmfL6Yc2s2XpsmWrx8c0Meta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/students/[studentId].vue?macro=true";
import { default as _91teacherId_93ANGHM4eaXhxIar6vEti6Dt4E31KseYeM85PgMmbbCfoMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/teachers/[teacherId].vue?macro=true";
import { default as indexJ4IbJ8Rm_6U3_45gRqOvbPLqLG_45O_45GjIZ4vlTi9UgVaH8Meta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/district-admins/index.vue?macro=true";
import { default as _91managerId_930PgBCRsXYTX98lK4T5M7BFH4iHW86WAQjZudGmnfhpgMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/school-admins/[managerId].vue?macro=true";
import { default as _91districtAdminId_934973kZv41yiSm1_45t_7Rhr6wmxXl0veAK8RUWdIFfbWIMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/district-admins/[districtAdminId].vue?macro=true";
import { default as indexNy0LmnLoR6acAFAC2_45XwUMhY1D5bV_45v1mgyCIADRrgoMeta } from "/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: index1JMfyR5uxmAxVAMCNwWyLFLkMFIP_45vKAlIfzNfa8cGUMeta || {},
    redirect: "/users",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginYtQa9SSmc3ZqUtC_3jL1kzHZ7vJtjHCZbJelGF3_45YuYMeta || {},
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/login.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: indexI3c4ByUkGpBpdfEj85UCmQOTgoxkl2fi72KPC6xOAagMeta || {},
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/users/index.vue")
  },
  {
    name: "accounts",
    path: "/accounts",
    meta: indexogOFUltNIzujgGBGeGpfzY6gaY7kpDskrlY5EHosOMUMeta || {},
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/index.vue")
  },
  {
    name: "login-password",
    path: "/login-password",
    meta: login_45passwordR1lcTWl9C7J4WsPDY9KS8VW5daDDwyncETSIj0tPm_cMeta || {},
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/login-password.vue")
  },
  {
    name: "users-new-role",
    path: "/users/new/:role()",
    meta: _91role_93SQMt0_9T5qLuyCLZJNXDhNVQMaoBinfiQJo8iRccZQIMeta || {},
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/users/new/[role].vue")
  },
  {
    name: "accounts-new-type",
    path: "/accounts/new/:type()",
    meta: _91type_93AwDTcoFheQDjPl4pAn9Kp6kQSoeb5LOL23AyVYK11A8Meta || {},
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/new/[type].vue")
  },
  {
    name: "users-userId",
    path: "/users/:userId()",
    meta: indexIMB13u9chmNSnBEhggd9IYonaPq6mIxi7HR_f35YKvIMeta || {},
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/users/[userId]/index.vue"),
    children: [
  {
    name: "users-userId-index-info",
    path: "info",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/users/[userId]/index/info.vue")
  }
]
  },
  {
    name: "student-progress",
    path: "/student-progress",
    meta: indexhdHcplbdaxoa05GEHn0KWrW4ogw_45Ziuupk3P3svbkU8Meta || {},
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/student-progress/index.vue")
  },
  {
    name: "accounts-accountId",
    path: "/accounts/:accountId()",
    meta: indexNy0LmnLoR6acAFAC2_45XwUMhY1D5bV_45v1mgyCIADRrgoMeta || {},
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index.vue"),
    children: [
  {
    name: "accounts-accountId-index-info",
    path: "info",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/info.vue")
  },
  {
    name: "accounts-accountId-index-schools-new",
    path: "schools/new",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/schools/new.vue")
  },
  {
    name: "accounts-accountId-index-licenses-new",
    path: "licenses/new",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/licenses/new.vue")
  },
  {
    name: "accounts-accountId-index-students-new",
    path: "students/new",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/students/new.vue")
  },
  {
    name: "accounts-accountId-index-teachers-new",
    path: "teachers/new",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/teachers/new.vue")
  },
  {
    name: "accounts-accountId-index-schools",
    path: "schools",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/schools/index.vue")
  },
  {
    name: "accounts-accountId-index-classrooms-new",
    path: "classrooms/new",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/classrooms/new.vue")
  },
  {
    name: "accounts-accountId-index-licenses",
    path: "licenses",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/licenses/index.vue")
  },
  {
    name: "accounts-accountId-index-students",
    path: "students",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/students/index.vue")
  },
  {
    name: "accounts-accountId-index-teachers",
    path: "teachers",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/teachers/index.vue")
  },
  {
    name: "accounts-accountId-index-classrooms",
    path: "classrooms",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/classrooms/index.vue")
  },
  {
    name: "accounts-accountId-index-school-admins-new",
    path: "school-admins/new",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/school-admins/new.vue")
  },
  {
    name: "accounts-accountId-index-district-admins-new",
    path: "district-admins/new",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/district-admins/new.vue")
  },
  {
    name: "accounts-accountId-index-school-admins",
    path: "school-admins",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/school-admins/index.vue")
  },
  {
    name: "accounts-accountId-index-classrooms-groupId",
    path: "classrooms/:groupId()",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/classrooms/[groupId].vue")
  },
  {
    name: "accounts-accountId-index-licenses-licenseId",
    path: "licenses/:licenseId()",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/licenses/[licenseId].vue")
  },
  {
    name: "accounts-accountId-index-students-studentId",
    path: "students/:studentId()",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/students/[studentId].vue")
  },
  {
    name: "accounts-accountId-index-teachers-teacherId",
    path: "teachers/:teacherId()",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/teachers/[teacherId].vue")
  },
  {
    name: "accounts-accountId-index-district-admins",
    path: "district-admins",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/district-admins/index.vue")
  },
  {
    name: "accounts-accountId-index-school-admins-managerId",
    path: "school-admins/:managerId()",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/school-admins/[managerId].vue")
  },
  {
    name: "accounts-accountId-index-district-admins-districtAdminId",
    path: "district-admins/:districtAdminId()",
    component: () => import("/codebuild/output/src489166772/src/cb-admin/pages/accounts/[accountId]/index/district-admins/[districtAdminId].vue")
  }
]
  }
]